"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setScope(binding, scope) {
    const scopeMethodKeys = {
        Transient: "inTransientScope",
        Request: "inRequestScope",
        Singleton: "inSingletonScope",
    };
    return binding[scopeMethodKeys[scope]]();
}
exports.default = setScope;
